/**
 * @group Legal
 * @summary <blockquote>Registered business legal name used in legal documents and policies.</blockquote>
 *
 * @remarks
 * Replace the placeholder value with the official legal entity name of the operating company.
 * This value is referenced from other legal constants to avoid hardcoding the name in multiple places.
 *
 * @example
 * ```typescript
 * import { BUSINESS_LEGAL_NAME } from '@shared/constants';
 * console.log(BUSINESS_LEGAL_NAME);
 * ```
 */
export const BUSINESS_LEGAL_NAME = 'PHILA WEALTH (PTY) LTD';


